import workspaceQuery from '../../../graphql/queries/product/ProductUsagesLiveQuery.graphql';
import fragment from '../../../graphql/fragments/product/ProductUsageFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const ProductUsage: EntityType = {
  type: 'ProductUsage',
  title: 'Product Usage',
  workspaceUrl: '/Products/ProductUsage/Workspace/',
  workspace: workspaceQuery,
  fragment,
  screenReference: 'PRODUCTS_PRODUCT_USAGE',
};

export default ProductUsage;
